import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from '#src/shared/error';

import type { PaginatedContextData, PaginatedData } from '#src/app/shared/contexts/asyncData';

import { LocalPetitionUpdates } from './api.graphql';
import type { LocalPetitionUpdatesQuery, LocalPetitionUpdatesQueryVariables } from './api.graphql';
import type { LocalPetitionUpdatesItem } from './types';

type LocalPetitionUpdatesApiData = PaginatedData<
	LocalPetitionUpdatesItem,
	{
		totalCount: number;
	}
>;

/** @knip-ignore */
export type LocalPetitionUpdatesData = PaginatedContextData<LocalPetitionUpdatesApiData>;

async function getData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
	cursor?: string,
): Promise<LocalPetitionUpdatesApiData> {
	const { data } = await fetch<LocalPetitionUpdatesQuery, LocalPetitionUpdatesQueryVariables>({
		query: LocalPetitionUpdates,
		variables: { slug, cursor: cursor ?? null },
		rejectOnError: true,
	});

	if (!data.localPageLocation) throw new NotFoundError();

	return {
		items: data.localPageLocation.petitionUpdatesConnection.nodes,
		cursor: data.localPageLocation.petitionUpdatesConnection.pageInfo.endCursor,
		hasNextPage: data.localPageLocation.petitionUpdatesConnection.pageInfo.hasNextPage,
		totalCount: data.localPageLocation.petitionUpdatesConnection.totalCount,
	};
}

export async function getFirstPageData(utilityContext: UtilityContext, slug: string) {
	return getData(utilityContext, slug);
}

export async function getNextPageData(utilityContext: UtilityContext, cursor: string, slug: string) {
	return getData(utilityContext, slug, cursor);
}
